import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { IChartConfig } from '../../core/interfaces/IChartConfig';

@Component({
    selector: 'app-chart-wrapper',
    templateUrl: './chart-wrapper.component.html',
    styleUrl: './chart-wrapper.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'classes'
    },
    standalone: false
})
export class ChartWrapperComponent {

  @Input() set chartConfig(chartConfig: IChartConfig) {
    this._chartConfig = chartConfig;
    this._cdr.detectChanges();
  }
  @Input() isCustomizeModeEnable: boolean;
  @Input() showDeleteButton = false;

  private _chartConfig: IChartConfig;
  private readonly _cdr = inject(ChangeDetectorRef);

  public get chartConfig(): IChartConfig {
    return this._chartConfig;
  }

  public get classes(): string {
    return `col-xs-12 col-sm-12 col-md-${ this.chartConfig.size } full-width`;
  }
}
